export default __webpack_public_path__ + "static/media/01_Kom_HL.d40ac524.jpg";